export default __webpack_public_path__ + "92127c2ae099baf2eaf17c9e44a03248.png";